import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import {
    ICollaborator,
    ICollaboratorPayload,
    IPartialCollaboratorPayload,
} from '../../entities/Collaborator/Collaborator.ts';

export class CollaboratorApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Collaborators`;

    public static apiUrls: {
        getCollaborators: string;
        getCollaboratorById: string;
        postCollaborator: string;
        putCollaborator: string;
        deleteCollaborator: string;
        postPartialCollaborators: string;
        getPatientCollaboratorSummaries: string;
        getPatientCollaborators: string;
        getCollaboratorNew: string;
    } = {
        getCollaborators: `${CollaboratorApi.baseApiUrl}`,
        getCollaboratorById: `${CollaboratorApi.baseApiUrl}/:id`,
        postCollaborator: `${CollaboratorApi.baseApiUrl}`,
        putCollaborator: `${CollaboratorApi.baseApiUrl}/:id`,
        deleteCollaborator: `${CollaboratorApi.baseApiUrl}/:id`,
        postPartialCollaborators: `${BaseApi.apiUrl}/PartialCollaborators`,
        getPatientCollaboratorSummaries: `${BaseApi.apiUrl}/Patients/:id/CollaboratorSummaries`,
        getPatientCollaborators: `${BaseApi.apiUrl}/Patients/:id/Collaborators`,
        getCollaboratorNew: `${CollaboratorApi.baseApiUrl}/New`,
    };

    public static async getPatientCollaboratorSummaries(id: string): Promise<ICollaborator[]> {
        return this.sendApiRequest<ICollaborator[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPatientCollaboratorSummaries,
            data: undefined,
            id: id,
        });
    }

    public static async getPatientCollaborators(id: string): Promise<ICollaborator[]> {
        return this.sendApiRequest<ICollaborator[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPatientCollaborators,
            data: undefined,
            id: id,
        });
    }

    public static async getCollaborators(): Promise<ICollaborator[]> {
        return this.sendApiRequest<ICollaborator[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getCollaborators,
        });
    }

    public static async getCollaboratorNew(): Promise<ICollaborator> {
        return this.sendApiRequest<ICollaborator>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getCollaboratorNew,
        });
    }

    public static async getCollaboratorById(id: string): Promise<ICollaborator> {
        return this.sendApiRequest<ICollaborator>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getCollaboratorById,
            data: undefined,
            id: id,
        });
    }

    public static async postPartialCollaborators(data: IPartialCollaboratorPayload): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postPartialCollaborators,
            data: data,
        });
    }

    public static async postCollaborator(data: ICollaboratorPayload): Promise<ICollaborator> {
        return this.sendApiRequest<ICollaborator>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postCollaborator,
            data: data,
        });
    }

    public static async putCollaborator(id: string, data: ICollaboratorPayload): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putCollaborator,
            data: data,
            id: id,
        });
    }

    public static async deleteCollaborator(id: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deleteCollaborator,
            data: undefined,
            id: id,
        });
    }
}
